let isDev = process.env.NODE_ENV === "development";

const URLS = {
  ARBITER_BASE_URL: "API-ENDPOINT",
  ARBITER_BASE_PATH: isDev ? "/arbiter" : "/arbiter",
  ARBITER_API_BASE_PATH: "/api/v1",
  ARBITER_API_TRANSACTIONS: "/api/v1/transactions",
  ARBITER_API_TRANSACTION_TYPES: "/api/v1/transactions/types",
  ARBITER_API_TRANSACTION_TYPE: "/api/v1/transaction-types",
  ARBITER_API_TRANSACTIONS_STORES: "/api/v1/transactions/stores",
  ARBITER_API_TRANSACTION_GROUPS: "/api/v1/transaction-groups",
  ARBITER_API_TRANSACTIONS_GROUPS: "/api/v1/transactions/groups",
  ARBITER_API_TRANSACTION_TIMELINES: "/api/v1/transaction-timelines",

  ARBITER_API_SCRIPTS: "/api/v1/scripts",

  ARBITER_API_SETTLEMENT_REQUESTS: "/api/v1/settlements/requests",
  ARBITER_API_SETTLEMENT_REQUEST_STATUSES: "/api/v1/settlements/requests/statuses",
  ARBITER_API_SETTLEMENT: "/api/v1/settlements",

  ARBITER_API_DISPUTES: "/api/v1/disputes",
  ARBITER_API_DISPUTES_BULK: "/api/v1/disputes/bulk/disputes",
  ARBITER_API_DISPUTES_BULK_ACCEPT_OR_DECLINE: "/api/v1/disputes/bulk",
  ARBITER_API_DISPUTES_BATCHES: "/api/v1/disputes/batches",
  ARBITER_API_DISPUTE_TIMELINES: "/api/v1/dispute-timelines",
  ARBITER_API_REASON_CODES: "/api/v1/reason-codes",
  ARBITER_API_DISPUTE_REGIONS: "/api/v1/dispute-regions",
  ARBITER_API_DISPUTES_CATEGORIES: "/api/v1/disputes/categories",
  ARBITER_API_DISPUTES_BULK_DECLINE_CATEGORIES : "/api/v1/disputes/bulk-decline-categories",
  ARBITER_API_DISPUTES_CATEGORIES_BULK: "/api/v1/disputes/bulk/categories",
  ARBITER_API_DISPUTES_DECLINE_TEMPLATE : "/api/v1/disputes/bulk/decline/templates",
  ARBITER_API_DISPUTES_BULK_DECLINE : "/api/v1/disputes/bulk/decline",
  ARBITER_API_DOWNLOAD_TEMPLATE: "/api/v1/batches/templates",
  ARBITER_API_DOWNLOAD_ERROR_FILE: "/api/v1/batches/files",
  ARBITER_API_DISPUTES_ACQUIRERS: "/api/v1/disputes/acquirers",
  ARBITER_API_DISPUTES_ISSUERS: "/api/v1/disputes/issuers",
  ARBITER_API_DISPUTES_MERCHANTS: "/api/v1/disputes/merchants",
  ARBITER_API_BULK_ACCEPT: "/api/v1/disputes/bulkUpdates",

  ARBITER_API_MERCHANT_DISPUTANTS: "/api/v1/merchant-disputants",

  ARBITER_API_SETTINGS_CONFIG: "/api/v1/settings",
  ARBITER_API_SETTINGS_CONFIG_BY_TYPE: "/api/v1/settings/type",
  ARBITER_API_SETTINGS_CONFIG_TYPES: "/api/v1/settings/types/all",

  ARBITER_API_GET_COUNTRIES: "/api/v1/dispute-regions/countries",

  USER_API_USER_PERMISSIONS: "/user/permissions",
  USER_API: "/user",

  ARBITER_API_SETTLEMENT_RULES: "/api/v1/settlement-rules",
  ARBITER_API_GET_SETTLEMENT_RULES_LABEL: "/api/v1/settlement-rules/labels",

  ARBITER_API_SETTLEMENT_REPORTS: "/api/v1/settlements/reports",
  ARBITER_API_SETTLEMENT_REPORTS_FILES: "/api/v1/files",
  ARBITER_PUBLIC_FOLDER_URL:
    "https://mufasa.interswitchng.com/p/arbiter-api/help",
  ISW_CUSTOMER_PORTAL_URL: "https://help.interswitchgroup.com",

  ARBITER_API_DISCOVER_TRANSACTIONS: "/api/v1/dnds/transactions",
  ARBITER_API_DISCOVER_REASONCODES: "/api/v1/dnds/cases/reasons",
  ARBITER_API_DISCOVER_CASES: "/api/v1/dnds/cases",
  ARBITER_API_CARD_ACCEPTOR: "/api/v1/card-acceptors",

  REPORTS: "/api/v1/reports",
  REPORT: (reportType) => {
    return `/api/v1/${reportType}/reports`;
  },
};
export default URLS;



// WEBPACK FOOTER //
// ./src/configurations/urls.js